module.exports = __webpack_public_path__ + "media/fonts/avenir/Avenir-Heavy-c4707c4b3a06631ab72b7541c2c3c688.woff";